export const ItemFilter = (item, itemKey, comparator) => (
    item.filter(data =>
        data[itemKey] === comparator
    )
);
